export const IS_LOCKED_ATTRIBUTE = 'data-is-locked-content';
export const IS_ENABLED_ATTRIBUTE = 'data-is-enabled';
export const MENU_ITEMS_NAME_ATTRIBUTE = 'data-nice-name';
export const MENU_ITEMS_SELECTOR = `[${ MENU_ITEMS_NAME_ATTRIBUTE }]`;
export const CMS_ENTITIES_UNWRAPPED_SELECTOR = '[data-cms-entities-unwrapped]';
export const CMS_ENTITIES_WRAPPED_SELECTOR = '[data-cms-entities-wrapped]';

